module.exports = __webpack_public_path__ + "img/01.5b8b8c33.jpg";